<script>import Icon from '../Icon.svelte';
const iconNode = [["path", { "d": "M5 12h14" }]];
</script>

<Icon name="minus" {...$$props} iconNode={iconNode}>
  <slot/>
</Icon>
